/**
 * Created by 胜 on 2017/6/11.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {renderMoney} from '../../utils';

class LecturePayLecturesPanel extends Component {
    render() {
        const {lectures} = this.props;
        return (
            <div>
                {lectures.map((item, index) => (
                    <div className="weui-actionsheet__cell weui-padding bg-cell-item" key={index}>
                        <div className="weui-flex">
                            <span className="weui-flex__item text-ellipsis text-left flex_3">
                                <p className="text-ellipsis cell-item-title-color">{item.name}</p>
                            </span>
                            {item.money > 0 &&
                            <span className="weui-flex__item flex_1 text-medium text-grey text-right">
                                ¥{renderMoney(item.money)}
                            </span>
                            }
                        </div>
                    </div>
                ))
                }
            </div>
        )
    }
}

export default connect((state) => ({
    lectures: state.lecture.channel.lectures
}))(LecturePayLecturesPanel)


// WEBPACK FOOTER //
// ./src/components/lecture/LecturePayLecturesPanel.js